module.exports = __webpack_public_path__ + "static/media/blackgithub.4ac5b777.png";